import Upsertable from '@/models/Upsertable'
import { useSoilTestStore } from '@/stores/soilTestStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class SoilTest extends Upsertable {
  static store() {
    return useSoilTestStore()
  }

  store() {
    return SoilTest.store()
  }

  static all() {
    return SoilTest.store().all()
  }

  static find(uuid) {
    const obj = SoilTest.store().find(uuid)
    let soilTest = new SoilTest()
    return Object.assign(soilTest, obj)
  }

  static findAllByCustomerUuid(customerUuid) {
    return SoilTest.store().findAllByCustomerUuid(customerUuid)
  }
}

useModelName(SoilTest, "SoilTest")

ModelRegistry.register(SoilTest, 'SoilTest')
